import React, { useRef, useState } from "react";
import moment from 'moment';
import { Button, ButtonGroup, Checkbox, Glyphicon, Overlay, OverlayTrigger, Tooltip } from "react-bootstrap";
import ConfirmOverlay from "../../UI/ConfirmOverlay";
import DeleteConfirmOverlay from "../../UI/DeleteConfirmOverlay";
import CountDown from "../../CountDown";
import { usePagesContext } from "../PagesSettings/context/PagesContext";
import { LinkContainer } from "react-router-bootstrap";
import MoveIcon from "../Widgets/components/Icons/MoveIcon";

const checkIsInProgress = (quiz) => {
    return quiz.modalStartAt
        // && (moment.unix(quiz.modalStartAt).isBefore(moment()))
        && (!quiz.modalTimeout || moment.unix(quiz.modalStartAt + quiz.modalTimeout).isAfter(moment()))
}

const ControlOverlay = ({ text, id, children }) => {
    return (
        <OverlayTrigger placement="top" overlay={(<Tooltip id={`tooltip-poll${id}`}>{text}</Tooltip>)}>
            {children}
        </OverlayTrigger>
    );
};

export default ({ event, quizzes, quiz, onChangeQuiz, onClickEdit, onClickDelete, onClickStop, onClickLaunch, onClickShowResult, getQuizzesLink, isSaving }) => {
    const playButtonRef = useRef(null);
    const stopButtonRef = useRef(null);
    const deleteButtonRef = useRef(null);
    const [playButtonShow, setPlayButtonShow] = useState(false);
    const [stopButtonShow, setStopButtonShow] = useState(false);
    const [deleteButtonShow, setDeleteButtonShow] = useState(false);

    const { pages } = usePagesContext();
    const isInProgress = checkIsInProgress(quiz);
    const activeTypes = quizzes.filter(quiz => checkIsInProgress(quiz)).map(quiz => quiz.participationType);
    const launchDisabled = false;
    // const launchDisabled = activeTypes.includes('') || activeTypes.includes(quiz.participationType) || (!quiz.participationType && activeTypes.length);

    return (
        <>
            <td width={40}><MoveIcon /></td>
            <td width={40}>{quiz.id}</td>
            <td style={{minWidth: 70}}>{quiz.titleRu}</td>
            <td width={100}>
                <Checkbox
                    checked={quiz.enabled}
                    onChange={(e) => onChangeQuiz(quiz, { enabled: e.target.checked })}
                    disabled={isInProgress}
                    inline
                    bsClass=""
                />
            </td>
            <td width={100}>
                <Checkbox
                    checked={quiz.visible}
                    onChange={(e) => onChangeQuiz(quiz, { visible: e.target.checked })}
                    inline
                    bsClass=""
                />
            </td>
            <td width={150}>
                {quiz.participationType === "online" ? "Онлайн зрители" : quiz.participationType === "offline" ? "Оффлайн зрители" : "Все зрители"}
            </td>
            <td width={200}>{event.stream?.filter(({ id }) => quiz.displayStreams?.includes(String(id))).map(stream => stream.description_ru || stream.description_en).join(", ") || "Залы не выбраны"}</td>
            <td width={200}>{pages?.filter(({ path }) => quiz.displayPage?.includes(path)).map(page => page.titleRu || page.titleEn).join(", ") || "Страницы не выбраны"}</td>
            <td width={200}>
                <span style={{ width: "4rem" }}>
                    {isInProgress ? <>
                        {"Запущен" + (!!quiz.modalTimeout ? ", до завершения " : "")}
                        {!!quiz.modalTimeout && <CountDown
                            time={quiz.modalStartAt + quiz.modalTimeout}
                            onTimeOut={() => onClickStop(quiz.id)}
                        />}
                    </>
                        : launchDisabled ? "Не может быть запущен для этой аудитории"
                            : "Ожидает запуска"
                    }
                </span>
            </td>
            <td width={100}>
                <div style={{ display: "flex", gap: 10, alignItems: 'center' }}>
                    {isInProgress ?
                        <>
                            <DeleteConfirmOverlay title="Остановить этот квиз?" buttonText="Остановить" onConfirm={() => onClickStop(quiz.id)}>
                                <Button
                                    ref={stopButtonRef}
                                    onMouseEnter={() => setStopButtonShow(true)}
                                    onMouseLeave={() => setStopButtonShow(false)}
                                    disabled={isSaving}
                                >
                                    <Glyphicon glyph="stop" />
                                </Button>
                            </DeleteConfirmOverlay>
                            <Overlay target={stopButtonRef.current} show={stopButtonShow} placement="top">
                                <Tooltip id="stop-button">
                                    Остановить квиз
                                </Tooltip>
                            </Overlay>
                        </>
                        :
                        <>
                            <ConfirmOverlay
                                title={!launchDisabled && quiz.enabled ? "Запустить этот квиз?" : "Невозможно запустить"}
                                buttonText="Запустить"
                                onConfirm={() => onClickLaunch(quiz.id)}
                                warning={!quiz.enabled ? "Этот квиз не активен"
                                    : launchDisabled ? "Уже запущен квиз для этой аудитории"
                                        : !quiz.polls?.length ? "В квизе нет вопросов"
                                            : null
                                }
                            >
                                <Button
                                    ref={playButtonRef}
                                    onMouseEnter={() => setPlayButtonShow(true)}
                                    onMouseLeave={() => setPlayButtonShow(false)}
                                    disabled={isSaving}
                                >
                                    <Glyphicon glyph="play" />
                                </Button>
                            </ConfirmOverlay>
                            <Overlay target={playButtonRef.current} show={playButtonShow} placement="top">
                                <Tooltip id="play-button">
                                    Запустить квиз
                                </Tooltip>
                            </Overlay>
                        </>
                    }
                </div>
            </td>
            <td width={150}>
                <ButtonGroup>
                    <ControlOverlay text="Открыть на платформе" id="quiz-platform">
                        <Button href={getQuizzesLink(event, quiz)} target="_blank"><Glyphicon glyph="new-window" /></Button>
                    </ControlOverlay>
                    <ControlOverlay text="Открыть QR-код" id="quiz-qrcode">
                        <LinkContainer to={`/event/${event.eventPassword}/offline/qr/quiz/active-quiz-key/${quiz.quizKey}`}>
                            <Button><Glyphicon glyph="qrcode" /></Button>
                        </LinkContainer>
                    </ControlOverlay>
                    <ControlOverlay text="Скачать QR-код" id="poll-qrcode-download">
                        <Button href={`/quizzes/${event.eventKey}/qr/download?active-quiz-key=${quiz.quizKey}`} target="_blank"><Glyphicon glyph="download-alt" /></Button>
                    </ControlOverlay>
                </ButtonGroup>
            </td>
            <td width={40}>
                <ControlOverlay text="Показать результаты" id="quiz-results">
                    <Button onClick={() => onClickShowResult(quiz.id)}><Glyphicon glyph="signal" /></Button>
                </ControlOverlay>
            </td>
            <td width={40}>
                <ControlOverlay text="Редактировать" id="quiz-edit">
                    <Button disabled={isInProgress} bsSize="small" onClick={() => onClickEdit(quiz)}><Glyphicon glyph="pencil" /></Button>
                </ControlOverlay>
            </td>
            <td width={40}>
                <DeleteConfirmOverlay title="Точно удалить квиз?" buttonText="Удалить" onConfirm={() => onClickDelete(quiz)}>
                    <Button
                        ref={deleteButtonRef}
                        bsSize="small"
                        bsStyle="danger"
                        onMouseEnter={() => setDeleteButtonShow(true)}
                        onMouseLeave={() => setDeleteButtonShow(false)}
                        disabled={isSaving}
                    >
                        <Glyphicon glyph="trash" />
                    </Button>
                </DeleteConfirmOverlay>
                <Overlay target={deleteButtonRef.current} show={deleteButtonShow} placement="top">
                    <Tooltip id="delete-button">
                        Удалить квиз
                    </Tooltip>
                </Overlay>
            </td>
        </>
    )
}